import CardGrid from '../components/CardGrid';
import { waterActivities } from '../data/water';

export default function WaterActivities() {
  const items = waterActivities.map(a => ({
    id: a.id,
    title: a.title,
    description: a.description,
    image: a.image,
    cta: { label: 'Inquire', href: '/contact' }
  }));
  return (
    <section className="section">
      <h2>Water Activities</h2>
      <p className="muted">Sailing, snorkeling, diving, kitesurfing and more.</p>
      <CardGrid items={items} />
    </section>
  );
}
